import tippy from 'tippy.js/dist/tippy-bundle.umd.min.js';

const Map = () => {

	const mapButtons = document.querySelectorAll('[data-button]');

	Array.from(mapButtons).forEach(map_button => {

		if (typeof map_button != "undefined" && map_button != null) {

		}
	});

	var mapElements = document.querySelectorAll('.map path, .map polygon');

	Array.from(mapElements).forEach(mapElement => {

		mapElement.classList.remove('is-current', 'is-hover');
			
		mapElement.addEventListener('mouseenter', () => {
		
			let map_id = mapElement.id;

			Array.from(mapElements).forEach(other_elements => {
				other_elements.classList.remove('is-hover');
			});

			if (typeof map_id != "undefined" && map_id != null) {
					mapElement.classList.add('is-hover');
			}
		});

		mapElement.addEventListener('mouseleave', () => {
			mapElement.classList.remove('is-hover');
		});

	});

	// add tippy to each path
	document.querySelectorAll('path[data-template]').forEach(btn => {
		tippy(btn, {
			content(reference) {
				const id = reference.getAttribute('data-template');
				const template = document.getElementById(id);
				return template.innerHTML;
			},
			allowHTML: true,
			followCursor: true,
			hideOnClick: false,
		})
	})


};

export default Map;